import { render, staticRenderFns } from "./PopoverChannel.vue?vue&type=template&id=1cc606c5&scoped=true&"
import script from "./PopoverChannel.vue?vue&type=script&lang=js&"
export * from "./PopoverChannel.vue?vue&type=script&lang=js&"
import style0 from "./PopoverChannel.vue?vue&type=style&index=0&id=1cc606c5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc606c5",
  null
  
)

export default component.exports